<div class="gtmpage-browse-by-subjects">
    <div [ngStyle]="{ 'background-image': 'url(\'' + bannerBg + '\')' }" class="banner">
        <app-browsing-header></app-browsing-header>
        <app-subjects *ngIf="nodeDepth === 1"></app-subjects>
    </div>

    <ng-container *ngIf="nodeDepth !== 1 && (isTablet$ | async).matches">
        <div class="container pb-4">
            <div class="row-auto px-sm-8 px-md-0">
                <!-- TOPICS -->
                <div class="col-12 col-md-6 d-flex flex-column pb-4 pb-md-0">
                    <span
                        class="pb-4 align-self-center align-self-md-start fw-bold"
                        [ngStyle]="{ color: colorCode }"
                    >
                        Topic Filter:
                    </span>
                    <ng-select
                        [(ngModel)]="selectedTopic"
                        [placeholder]="'Choose topic'"
                        (change)="onNodeChange($event)"
                    >
                        <ng-option *ngFor="let topic of availableTopics" [value]="topic">
                            {{ topic.title }}
                        </ng-option>
                    </ng-select>
                </div>

                <!-- SUBTOPICS -->
                <div *ngIf="selectedTopic" class="col-12 col-md-6 align-self-end">
                    <ng-select
                        [(ngModel)]="selectedSubTopic"
                        [placeholder]="'Choose subtopic'"
                        (change)="onNodeChange($event)"
                    >
                        <ng-option *ngFor="let subTopic of availableSubTopics" [value]="subTopic">
                            {{ subTopic.title }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="p-0 px-md-8 pb-md-8 pt-md-2 m-md-auto mw-1400">
        <div class="row-auto browsing-content-wrapper" id="resultsWrapper">
            <div
                *ngIf="nodeDepth > 1 && !(isTablet$ | async).matches"
                class="col-xs-12 col-sm-12 col-md-3 col-lg-3 topics-wrapper"
            >
                <app-topics></app-topics>
            </div>

            <div
                [ngClass]="{
                    'col-xs-12 col-sm-12 col-md-9 col-lg-9': nodeDepth > 1,
                    'col-xs-12 col-sm-12 col-md-12 col-lg-12':
                        nodeDepth <= 1 || (isTablet$ | async).matches,
                }"
                class="pe-0 pe-lg-1 ps-lg-6"
            >
                <app-browsing-results-group
                    [resultsPerRow]="resultsPerRow"
                ></app-browsing-results-group>
            </div>
        </div>
    </div>
    <app-available-features></app-available-features>
</div>
